document.addEventListener('DOMContentLoaded', function () {
  if (!Shopify.designMode) {

    /* ---------------------------------------------------
      AUTO-APPEND BLANK DATA ATTRIBUTES
    --------------------------------------------------- */

    const allSections = document.querySelectorAll('.shopify-section');

    Array.from(allSections)
      .filter(section => {
        const id = section.id || '';

        return (
          id.includes('shopify-section-template') &&
          !id.includes('main') &&
          !id.includes('production_tabs_section') &&
          !id.includes('production_update_section') &&
          !id.includes('production_timeline_section')
        );
      })
      .forEach(section => {
        const innerSection = section.querySelector(':scope > *');
        if (!innerSection) return;

        innerSection.setAttribute('data-appended-production-content', '');
      });

    const tabs = document.querySelectorAll('.tabsSection .tabButton');
    const productionContents = document.querySelectorAll('[data-production-content]');

    if (!productionContents.length) return;
    if (!tabs.length) return;

    /* ---------------------------------------------------
      URL PARAM HANDLING
    --------------------------------------------------- */

    const params = new URLSearchParams(window.location.search);
    const activeTabParam = params.get('active_tab');

    const validContentIds = Array.from(productionContents).map(
      content => content.dataset.productionContent
    );

    const initialTargetId = validContentIds.includes(activeTabParam)
      ? activeTabParam
      : tabs[0].dataset.showProductionContent;

    /* ---------------------------------------------------
      INITIAL STATE
    --------------------------------------------------- */

    tabs.forEach(tab => {
      const isActive = tab.dataset.showProductionContent === initialTargetId;

      tab.classList.toggle('button--FullSecondary', isActive);
      tab.classList.toggle('button--FullQuaternary', !isActive);
    });

    productionContents.forEach(content => {
      const contentId = content.dataset.productionContent;

      const isActive =
        contentId === initialTargetId ||
        contentId === 'all';

      content.classList.toggle('ProductionSection--Active', isActive);
      content.style.display = isActive ? '' : 'none';
    });

    /* ---------------------------------------------------
      CLICK HANDLERS
    --------------------------------------------------- */

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.showProductionContent;

        tabs.forEach(btn => {
          btn.classList.remove('button--FullSecondary');
          btn.classList.add('button--FullQuaternary');
        });

        tab.classList.remove('button--FullQuaternary');
        tab.classList.add('button--FullSecondary');

        productionContents.forEach(content => {
          const contentId = content.dataset.productionContent;

          const isActive =
            contentId === targetId ||
            contentId === 'all';

          content.classList.toggle('ProductionSection--Active', isActive);
          content.style.display = isActive ? '' : 'none';
        });
      });
    });

  }
});